import { I18n } from 'aws-amplify'

export const String = () => ({
  title: I18n.get('Time'),
  save: I18n.get('Save'),
  selectTimeMode: I18n.get('Select a time format'),
  '24h': I18n.get('24h'),
  '12h': I18n.get('12h')
})
